// ABTestUtils.js
import { gtag } from './GoogleTagUtils';

// Constants for the pricing A/B test
export const PRICING_TEST_ID = 'pricing_ab_test';
export const PRICING_TEST_VARIANTS = {
  ANNUAL: 'annual',
  MONTHLY: 'monthly'
};

// Stripe URLs for each pricing option
export const STRIPE_URLS = {
  [PRICING_TEST_VARIANTS.ANNUAL]: 'https://buy.stripe.com/28o7wcbEBfzE9dS7tg',
  [PRICING_TEST_VARIANTS.MONTHLY]: 'https://buy.stripe.com/7sI5o48sp87cbm03cZ'
};

// Function to assign a user to a test variant
export const assignToVariant = (testId, variants) => {
  // Use localStorage to persist the user's variant assignment
  const storageKey = `ab_test_${testId}`;
  const storedVariant = localStorage.getItem(storageKey);
  
  if (storedVariant) {
    console.log(`[AB Test] Using stored variant: ${storedVariant}`);
    return storedVariant;
  }
  
  // Randomly assign to a variant if not already assigned
  const random = Math.random();
  const variant = random < 0.5 ? PRICING_TEST_VARIANTS.ANNUAL : PRICING_TEST_VARIANTS.MONTHLY;
  
  console.log(`[AB Test] Random number: ${random}, Assigned variant: ${variant}`);
  localStorage.setItem(storageKey, variant);
  
  // Track the assignment in Google Analytics
  if (window.gtag) {
    window.gtag('event', 'ab_test_assigned', {
      test_id: testId,
      variant: variant
    });
  }
  
  return variant;
};

// Function to track pricing option clicks
export const trackPricingClick = (variant, price) => {
  if (window.gtag) {
    window.gtag('event', 'pricing_option_clicked', {
      event_category: 'Pricing',
      event_label: variant,
      value: price
    });
  }
}; 